import { Injectable } from "@angular/core";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { TelemetryEventPayload, TelemetryFieldEventPayload } from "./registration-telemetry.model";

export const ACTION_PREFIX = "[Registration Telemetry]";

export const REGISTRATION_TELEMETRY_ACTION_TYPE = {
	uiInteractionEvent: `${ACTION_PREFIX} UI Interaction Event ${SYNC_SUFFIX}`,
	uiInteractionFieldEvent: `${ACTION_PREFIX} UI Interaction Field Event ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class RegistrationTelemetryAction {
	uiInteractionEvent(payload: TelemetryEventPayload): ActionWithPayload {
		return {
			type: REGISTRATION_TELEMETRY_ACTION_TYPE.uiInteractionEvent,
			payload,
		};
	}

	uiInteractionFieldEvent(payload: TelemetryFieldEventPayload): ActionWithPayload {
		return {
			type: REGISTRATION_TELEMETRY_ACTION_TYPE.uiInteractionFieldEvent,
			payload,
		};
	}
}
